import { z } from "zod";

import { packNetAxios } from "@/lib/api-client";
import { type OrderAudit, orderAuditSchema } from "@/schemas/walmart-connector";

import { baseRoutes } from "./base-routes";

export type FilterType = "CorrelationId" | "OrderId" | "PickTicketId";

export const getOrdersAuditPreview = async (): Promise<OrderAudit[]> => {
	const response = await packNetAxios.get(`${baseRoutes.walmartConnector}/v2/OrderAudit/recent`);

	z.array(orderAuditSchema).enrich({ callSite: "getOrdersAuditPreview" }).safeParseWithTelemetry(response.data);

	return response.data as OrderAudit[];
};

export const getOrderAudit = async (searchField: FilterType, filter: string): Promise<OrderAudit> => {
	const response = await packNetAxios.get(`${baseRoutes.walmartConnector}/v2/OrderAudit`, {
		params: { searchField, query: filter },
	});

	orderAuditSchema.enrich({ callSite: "getOrderAudit" }).safeParseWithTelemetry(response.data);

	return response.data as OrderAudit;
};

export async function getVersion(): Promise<string> {
	const response = await packNetAxios.get<string>(`${baseRoutes.walmartConnector}/version`);
	return response.data;
}
